import React from 'react';

/** Reference Copy, final, verbatim. Do not reword. */
const BULLETS = [
  'We found these matches between your Collection and what other traders are looking for.',
  'Points let you take a trade you couldn’t otherwise afford, the difference is settled in points, not cards.',
  'You build the full trade on the next page. Nothing is sent yet.',
  'Your trading partner approves or declines before any cards move.',
];

/**
 * Persistent explainer below the deck. Always visible — not a disclosure, not
 * dismissible — because the surface shows one suggestion at a time and a new
 * user has no list context to infer the model from.
 */
const SuggestionHelpBlock: React.FC = () => (
  <section className="sugg-help" aria-label="How suggested trades work">
    <h2 className="sugg-help-heading">HOW SUGGESTED TRADES WORK</h2>
    <ul className="sugg-help-bullets">
      {BULLETS.map((bullet) => (
        <li key={bullet}>{bullet}</li>
      ))}
    </ul>
  </section>
);

export default SuggestionHelpBlock;
